<template>
  <div class="mobile-introduction">
    <!-- Banner -->
    <div class="mobile-intro-banner">
      <img src="../../../assets/aboutSailHero/img/banner_1.jpg" alt="先河介绍" class="mobile-intro-banner__image">
      <div class="mobile-intro-banner__overlay"></div>
      <div class="mobile-intro-banner__content">
        <h1 class="mobile-intro-banner__title">先河介绍</h1>
        <p class="mobile-intro-banner__subtitle">ABOUT SAILHERO</p>
      </div>
    </div>

    <div class="mobile-intro-container">
      <!-- 公司介绍 -->
      <section class="mobile-intro-section">
        <div class="mobile-intro-card">
          <div class="mobile-intro-card__header">
            <h2 class="mobile-intro-card__title">
              <span class="mobile-intro-card__title-icon"></span>
              公司介绍
            </h2>
          </div>
          <div class="mobile-intro-card__body">
            <div class="mobile-intro-content" v-html="companyContent"></div>
          </div>
        </div>
      </section>

      <!-- 董事长致辞 -->
      <section class="mobile-intro-section">
        <div class="mobile-intro-card">
          <div class="mobile-intro-card__header">
            <h2 class="mobile-intro-card__title">
              <span class="mobile-intro-card__title-icon"></span>
              董事长致辞
            </h2>
          </div>
          <div class="mobile-intro-card__body">
            <div class="mobile-intro-content" v-html="chairmanContent"></div>
          </div>
        </div>
      </section>

      <!-- 光辉历程 -->
      <section class="mobile-intro-section" v-if="historyData && historyData.length > 0">
        <div class="mobile-intro-card">
          <div class="mobile-intro-card__header">
            <h2 class="mobile-intro-card__title">
              <span class="mobile-intro-card__title-icon"></span>
              光辉历程
            </h2>
          </div>
          <div class="mobile-intro-card__body">
            <div class="mobile-intro-history">
              <!-- 横向滚动的时间轴 -->
              <div class="mobile-intro-history__timeline">
                <div class="mobile-intro-history__timeline-scroll">
                  <div 
                    v-for="(item, index) in historyData" 
                    :key="index"
                    :class="['mobile-intro-history__node', { 'is-active': selectedHistoryIndex === index }]"
                    @click="selectHistory(index)"
                  >
                    <div class="mobile-intro-history__dot"></div>
                    <div class="mobile-intro-history__year">{{ item.year }}</div>
                  </div>
                </div>
                <div class="mobile-intro-history__line"></div>
              </div>
              
              <!-- 详细内容区域 -->
              <div class="mobile-intro-history__content" v-if="selectedHistory">
                <div class="mobile-intro-history__content-scroll">
                  <h3 class="mobile-intro-history__content-title">{{ selectedHistory.year }}</h3>
                  <div class="mobile-intro-history__content-text" v-html="selectedHistory.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 资质荣誉 -->
      <section class="mobile-intro-section" v-if="honorsData && honorsData.length > 0">
        <div class="mobile-intro-card">
          <div class="mobile-intro-card__header">
            <h2 class="mobile-intro-card__title">
              <span class="mobile-intro-card__title-icon"></span>
              资质荣誉
            </h2>
          </div>
          <div class="mobile-intro-card__body">
            <div class="mobile-intro-honors">
              <div class="mobile-intro-honors__grid">
                <div 
                  v-for="(item, index) in currentHonorsPage" 
                  :key="index"
                  class="mobile-intro-honors__item"
                >
                  <div class="mobile-intro-honors__image-wrapper">
                    <img :src="getImageUrl(item.image)" :alt="item.title" class="mobile-intro-honors__image">
                  </div>
                  <p class="mobile-intro-honors__title">{{ item.title }}</p>
                </div>
              </div>
              <div class="mobile-intro-pagination" v-if="honorsPageCount > 1">
                <button 
                  class="mobile-intro-pagination__btn"
                  :disabled="honorsCurrentPage === 0"
                  @click="changeHonorsPage(-1)"
                  type="button"
                >
                  ‹
                </button>
                <span class="mobile-intro-pagination__text">
                  {{ honorsCurrentPage + 1 }} / {{ honorsPageCount }}
                </span>
                <button 
                  class="mobile-intro-pagination__btn"
                  :disabled="honorsCurrentPage === honorsPageCount - 1"
                  @click="changeHonorsPage(1)"
                  type="button"
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 概貌剪影 -->
      <section class="mobile-intro-section" v-if="galleryData && galleryData.length > 0">
        <div class="mobile-intro-card">
          <div class="mobile-intro-card__header">
            <h2 class="mobile-intro-card__title">
              <span class="mobile-intro-card__title-icon"></span>
              概貌剪影
            </h2>
          </div>
          <div class="mobile-intro-card__body">
            <div class="mobile-intro-gallery">
              <div class="mobile-intro-gallery__grid">
                <div 
                  v-for="(item, index) in currentGalleryPage" 
                  :key="index"
                  class="mobile-intro-gallery__item"
                >
                  <div class="mobile-intro-gallery__image-wrapper">
                    <img :src="getImageUrl(item.image)" :alt="item.caption" class="mobile-intro-gallery__image">
                  </div>
                  <p class="mobile-intro-gallery__caption" v-if="item.caption">{{ item.caption }}</p>
                </div>
              </div>
              <div class="mobile-intro-pagination" v-if="galleryPageCount > 1">
                <button 
                  class="mobile-intro-pagination__btn"
                  :disabled="galleryCurrentPage === 0"
                  @click="changeGalleryPage(-1)"
                  type="button"
                >
                  ‹
                </button>
                <span class="mobile-intro-pagination__text">
                  {{ galleryCurrentPage + 1 }} / {{ galleryPageCount }}
                </span>
                <button 
                  class="mobile-intro-pagination__btn"
                  :disabled="galleryCurrentPage === galleryPageCount - 1"
                  @click="changeGalleryPage(1)"
                  type="button"
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileIntroduction",
  data() {
    return {
      companyContent: '',
      chairmanContent: '',
      historyData: [],
      honorsData: [],
      galleryData: [],
      honorsCurrentPage: 0,
      galleryCurrentPage: 0,
      itemsPerPage: 4,  // 每页显示4个项目（2x2）
      selectedHistoryIndex: 0  // 选中的历程索引
    }
  },
  computed: {
    // 资质荣誉总页数
    honorsPageCount() {
      return Math.ceil(this.honorsData.length / this.itemsPerPage);
    },
    // 资质荣誉当前页数据
    currentHonorsPage() {
      const start = this.honorsCurrentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.honorsData.slice(start, end);
    },
    // 概貌剪影总页数
    galleryPageCount() {
      return Math.ceil(this.galleryData.length / this.itemsPerPage);
    },
    // 概貌剪影当前页数据
    currentGalleryPage() {
      const start = this.galleryCurrentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.galleryData.slice(start, end);
    },
    // 选中的历程详情
    selectedHistory() {
      if (this.historyData && this.historyData.length > 0) {
        return this.historyData[this.selectedHistoryIndex];
      }
      return null;
    }
  },
  methods: {
    // 获取公司介绍
    fetchCompanyContent() {
      let that = this;
      that.$api.post("/Client/getCompanyProfile", {},
        function (res) {
          if (res.code === "200") {
            that.companyContent = res.data.about_content;
          }
        },
        function (res) {
          console.error('获取公司介绍失败');
        }
      );
    },
    // 获取董事长致辞
    fetchChairmanContent() {
      let that = this;
      that.$api.post("/Client/getChairmanSpeech", {},
        function (res) {
          if (res.code === "200") {
            that.chairmanContent = res.data.about_content;
          }
        },
        function (res) {
          console.error('获取董事长致辞失败');
        }
      );
    },
    // 获取光辉历程
    fetchGloriousHistory() {
      let that = this;
      that.$api.post("/Client/getGloriousHistory", { pageSize: 1000, pageIndex: 1 },
        function (res) {
          if (res.code === "200" && res.data && res.data.length > 0) {
            that.historyData = res.data.map(item => ({
              year: item.about_name || item.history_year || '',
              content: item.about_content || item.history_content || ''
            }));
            // 默认选中最后一个时间节点
            that.selectedHistoryIndex = that.historyData.length - 1;
          }
        },
        function (res) {
          console.error('获取光辉历程失败');
        }
      );
    },
    // 获取资质荣誉
    fetchQualificationsHonors() {
      let that = this;
      that.$api.post("/Client/getQualificationsHonors", { pageSize: -1, pageIndex: -1 },
        function (res) {
          if (res.code === "200" && res.data && res.data.length > 0) {
            that.honorsData = res.data.map(item => ({
              title: item.about_name || item.honors_title || '资质荣誉',
              image: item.fileUrl || item.FilePath || ''
            }));
          }
        },
        function (res) {
          console.error('获取资质荣誉失败');
        }
      );
    },
    // 获取概貌剪影
    fetchOverviewSilhouette() {
      let that = this;
      that.$api.post("/Client/getOverviewSilhouette", { pageSize: -1, pageIndex: -1 },
        function (res) {
          if (res.code === "200" && res.data && res.data.length > 0) {
            that.galleryData = res.data.map(item => ({
              caption: item.about_name || item.silhouette_title || '',
              image: item.fileUrl || item.FilePath || ''
            }));
          }
        },
        function (res) {
          console.error('获取概貌剪影失败');
        }
      );
    },
    // 获取图片URL
    getImageUrl(path) {
      if (!path) return '';
      // 如果已经是完整URL，直接返回
      if (path.startsWith('http')) return path;
      // 如果path中已经包含完整路径（PC端的fileUrl已经处理过了），直接返回
      return path;
    },
    // 资质荣誉翻页
    changeHonorsPage(direction) {
      const newPage = this.honorsCurrentPage + direction;
      if (newPage >= 0 && newPage < this.honorsPageCount) {
        this.honorsCurrentPage = newPage;
      }
    },
    // 概貌剪影翻页
    changeGalleryPage(direction) {
      const newPage = this.galleryCurrentPage + direction;
      if (newPage >= 0 && newPage < this.galleryPageCount) {
        this.galleryCurrentPage = newPage;
      }
    },
    // 选择历程节点
    selectHistory(index) {
      this.selectedHistoryIndex = index;
    }
  },
  mounted() {
    this.fetchCompanyContent();
    this.fetchChairmanContent();
    this.fetchGloriousHistory();
    this.fetchQualificationsHonors();
    this.fetchOverviewSilhouette();
  }
}
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/introduction-mobile.css';
</style>

